import { Box, Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent, useQuote } from '~/hooks';
import { getPremiumClauses } from '~/utils';
const Clauses: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.additionalClauses' });

  const { premiums } = useQuote();

  const premiumClauses = premiums?.policy?.risks ? getPremiumClauses(premiums?.policy.risks) : {};

  return (
    <Box component="section">
      <Typography>{getTextContent('description')}</Typography>

      <Spacer size="md" />
      {Object.entries(premiumClauses).map(([className, clauses]) => (
        <React.Fragment key={className}>
          <Typography variant="h5" component="h2" gutterBottom>
            {className}
          </Typography>
          <Spacer size="sm" />
          {clauses.map((clause) => (
            <React.Fragment key={clause.subtitle}>
              <Typography variant="body1" component="h3" fontWeight="fontWeightMedium" gutterBottom>
                {clause.subtitle}
              </Typography>
              <Typography
                variant="body2"
                component="h3"
                sx={{ whiteSpace: 'break-spaces' }}
                gutterBottom
              >
                {clause.description.trimEnd()}
              </Typography>
              <Spacer size="sm" />
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default Clauses;
